<template>
	<div class="sf-flex-column">
		<div class="sf-col sf-col-3 p-0">
			<sf-card>
				<el-row :gutter="20">
					<el-col :span="6">
						<sf-input-group
							:label="getMessage_('SWCC000206')"
							readonly
							labelPosition="left"
							:labelSpan="12"
							:inputValue="selectedRow.pgmId"
						/>
					</el-col>
					<el-col :span="6">
						<sf-input-group
							:label="getMessage_('SWCC000581')"
							readonly
							labelPosition="left"
							:labelSpan="12"
							:inputValue="selectedRow.procId"
						/>
					</el-col>
					<el-col :span="12">
						<sf-group-wrapper :label="getMessage_('SWCC000584')" labelPosition="left" :labelSpan="6">
							<el-row :gutter="0">
								<el-col :span="12">
									<el-select :value="sqlDetails.syncType" :options="syncFlags" @change="value => onChange(value)">
										<el-option v-for="option in syncFlags" :key="option.value" :label="option.label" :value="option.value" />
									</el-select>
								</el-col>
								<!-- 매핑되는 변수를 알수 없음 -->
								<!-- <el-col :span="12">
									<el-input :value="input" />
								</el-col> -->
							</el-row>
						</sf-group-wrapper>
					</el-col>
				</el-row>
			</sf-card>
		</div>

		<div class="sf-col sf-col-21 p-0">
			<el-tabs type="border-card" class="h-100">
				<el-tab-pane v-for="pane in panes" :key="pane.label" :label="pane.label" class="h-100">
					<sql-detail-pane :db="pane.db" :sql="pane.sql" :scrId="scrId" />
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SyncManagement/store/helpers';
import SqlDetailPane from './SqlDetailPane';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		SqlDetailPane
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		panes() {
			return [
				{ label: 'Condition', db: 'condDb', sql: 'condSql' },
				{ label: 'Source', db: 'sourceDb', sql: 'sourceSql' },
				{ label: 'Target', db: 'targetDb', sql: 'targetSql' },
				{ label: 'Success', db: 'successResultSaveDb', sql: 'successResultSql' },
				{ label: 'Failed', db: 'failResultSaveDb', sql: 'failResultSql' }
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		onChange(value) {
			this.DEFAULT_ASSIGN({
				key: 'sqlDetails',
				value: {
					...this.sqlDetails,
					syncType: value
				}
			});
		}
	}
};
</script>

<style lang="scss"></style>
